import z from 'zod';

export const AppEnv = z.enum(['local', 'dev', 'stage', 'prod']);
export type AppEnv = z.infer<typeof AppEnv>;

export const appEnv =
  typeof window !== 'undefined' ? getClientAppEnv() : AppEnv.parse(process.env.APP_ENV);

function getClientAppEnv(): AppEnv {
  const { hostname } = window.location;

  if (hostname.endsWith('code.shojihomu.jp')) {
    return 'prod';
  } else if (hostname.endsWith('code-stage.shojihomu.jp')) {
    return 'stage';
  } else if (hostname.endsWith('code-dev.shojihomu.jp')) {
    return 'dev';
  }

  return 'local';
}

export const projectId =
  typeof window !== 'undefined' ? undefined : z.string().parse(process.env.GOOGLE_CLOUD_PROJECT);
